import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Button, CheckBox, FDropdown, Input ,GeneralDropdown} from "../../../../components";
import { useTranslation } from "react-i18next";
import { getNotificationAdmin, updateNotificationAdmin } from "../../../../services/apis/notification";
import { toast } from "react-toastify";
import { toastConfig } from "../../../../helpers/helper";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getUsersAdmin } from "../../../../services/apis/user";

const Notification = () => {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const {id} = useParams()
    const [notification,setNotification] = useState(null)


    console.log(id)
    const [loading,setLoading] = useState(false)



    useEffect(() => {
      const fetchNotification = async () => {

      try {
  
        const response = await getNotificationAdmin("",id);
        console.log(response)
        setNotification(response.data);
      } catch (error) {
        console.error('Error fetching notification:', error);
      } finally {
        setLoading(false);
      }
    }
      fetchNotification();
    }, [id]);
  


  return (
    <div className="bg-gradient-to-b from-[#FFFFFF] to-[#D7E2FF] p-10">
        <div className="w-[90%] mr-auto ml-auto">
        <div class="max-w-4xl mx-auto p-6 bg-white shadow-xl rounded-2xl space-y-6">
  <h2 class="text-2xl font-bold text-[#3E0292]">🔔 {t("adminNotification.list.notificationDetails")}</h2>
  <div>
    <p class="text-sm text-[#3E0292]">{t("adminNotification.list.notification")}</p>
    <p class="text-base text-gray-700 font-medium">
      {notification?.text}
    </p>
  </div>
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
    <div>
      <p class="text-sm text-[#3E0292]">{t("adminNotification.list.date")}</p>
      <p class="text-base font-medium text-gray-800">{notification?.createdAt}</p>
    </div>

    <div>
      <p class="text-sm text-[#3E0292]">{t("adminNotification.list.typeReceipnt")}</p>
      <p class="text-base font-medium text-gray-800">{notification?.recipientType}</p>
    </div>

    <div>
      <p class="text-sm text-[#3E0292]">{t("adminNotification.list.type")}</p>
      <p class="text-base font-medium text-gray-800">{notification?.type}</p>
    </div>
    {notification?.customUsers.length > 0 && (
    <div>
    <p class="text-sm text-[#3E0292]">{t("adminNotification.list.users")}</p>
    <p class="text-base font-medium text-gray-800">{notification?.customUsers?.map(user => user.fullName ?? user.phone).join(', ')}</p>
    </div>
    )}
  {notification?.recurrenceFrequency && (
    <div>
    <p class="text-sm text-[#3E0292]">{t("adminNotification.list.frequency")}</p>
    <p class="text-base font-medium text-gray-800">{notification?.recurrenceFrequency}</p>
    </div>
  )}

    <div>
      <p class="text-sm text-[#3E0292]">{t("adminNotification.list.schedualed")}</p>
      <p class="text-base font-medium text-gray-800">{notification?.scheduledTime}</p>
    </div>
  </div>

</div>
    </div>
    </div>
  );
};

export default Notification;